export default {
    updateUserConnections: function(connections) {
        return {type: 'USER_CONNECTIONS', connections};
    },
    updateEventConnections: function(eventId, connections, fetchTime) {
        return {type: 'EVENT_USER_CONNECTIONS', eventId, connections, fetchTime};
    },
};
